import ApiSetting from '@/request/api/setting'
import axios from '@/request/http'
// import querystring from 'querystring'

const topSwipeConfigApi = {
  list (params) {
    return axios.get(`${ApiSetting.baseUrl}/api/topswipe-config/`, {params: params})
  },
  detail (topSwipeConfigId, params) {
    return axios.get(`${ApiSetting.baseUrl}/api/topswipe-config/${topSwipeConfigId}/`, {params: params})
  }
}

export default topSwipeConfigApi
